import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

const Footer: React.FC = () => {
	const { t, i18n } = useTranslation()
	const lang = normalizeLanguage(i18n.language)

	return (
		<footer className='footer-container'>
			<div className='terms-container'>
				{/* Interni sadržaj — jezični prefiks se zadržava i otvara se u istom tabu */}
				<p><Link to={withLang(lang, '/blog')}>{t('footer.blog')}</Link></p>
				<p><Link to={withLang(lang, '/wedding-photo-app')}>{t('footer.photoApp')}</Link></p>
				<p><Link to={withLang(lang, '/privacy-policy')} target='_blank' rel="noreferrer">{t('footer.privacyPolicy')}</Link></p>
				<p><Link to={withLang(lang, '/terms-and-conditions')} target='_blank' rel="noreferrer">{t('footer.termsConditions')}</Link></p>
				<p><Link to={withLang(lang, '/refund-policy')} target='_blank' rel="noreferrer">{t('footer.refundPolicy')}</Link></p>
			</div>
			<p><a href='https://antonijaluketic.com' target='_blank' rel="noreferrer">{t('footer.designedBy')}</a> / <a href='https://mcode.hr/' target='_blank' rel="noreferrer">{t('footer.poweredBy')}</a></p>
			<p>{t('footer.craftedIn')}</p>
		</footer>
	)
}

export default Footer
